const secJcamp3 = `
##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (0.1.0)
##DATA TYPE=SIZE EXCLUSION CHROMATOGRAPHY
##DATA CLASS=NTUPLES
##ORIGIN=
##OWNER=
##XUNITS=MILLILITERS
##YUNITS=ARBITRARY UNITS
##FIRSTX=2.08555E+1
##LASTX=2.70598E+1
##MINX=20.8555
##MAXX=27.0598
##MINY=0.0
##MAXY=23.0813
##NPOINTS=376
##FIRSTY=0.00000E+0
##XUNITS=MILLILITERS
##YUNITS=ARBITRARY UNITS
##XYDATA=(XY..XY)
2.08555E+1, 0.00000E+0
2.08720E+1, 5.14929E-5
2.08886E+1, 9.99062E-3
2.09051E+1, 8.60308E-3
2.09217E+1, 3.07814E-2
2.09382E+1, 3.11942E-2
2.09548E+1, 4.60153E-2
2.09713E+1, 4.82632E-2
2.09878E+1, 7.53493E-2
2.10044E+1, 8.82731E-2
2.10209E+1, 1.11358E-1
2.10375E+1, 1.35673E-1
2.10540E+1, 1.57061E-1
2.10706E+1, 1.86926E-1
2.10871E+1, 2.07734E-1
2.11037E+1, 2.44712E-1
2.11202E+1, 2.70168E-1
2.11367E+1, 3.20901E-1
2.11533E+1, 3.55860E-1
2.11698E+1, 4.05779E-1
2.11864E+1, 4.58630E-1
2.12029E+1, 5.29605E-1
2.12195E+1, 5.97829E-1
2.12360E+1, 6.59222E-1
2.12526E+1, 7.36119E-1
2.12691E+1, 8.07739E-1
2.12856E+1, 8.93726E-1
2.13022E+1, 9.71442E-1
2.13187E+1, 1.06852E+0
2.13353E+1, 1.17004E+0
2.13518E+1, 1.29261E+0
2.13684E+1, 1.42027E+0
2.13849E+1, 1.53308E+0
2.14015E+1, 1.64351E+0
2.14180E+1, 1.76448E+0
2.14346E+1, 1.89881E+0
2.14511E+1, 2.03255E+0
2.14676E+1, 2.17761E+0
2.14842E+1, 2.32028E+0
2.15007E+1, 2.47479E+0
2.15173E+1, 2.63079E+0
2.15338E+1, 2.80821E+0
2.15504E+1, 2.98777E+0
2.15669E+1, 3.15956E+0
2.15835E+1, 3.32871E+0
2.16000E+1, 3.50577E+0
2.16165E+1, 3.70036E+0
2.16331E+1, 3.90160E+0
2.16496E+1, 4.10283E+0
2.16662E+1, 4.29721E+0
2.16827E+1, 4.49552E+0
2.16993E+1, 4.69661E+0
2.17158E+1, 4.90960E+0
2.17324E+1, 5.13129E+0
2.17489E+1, 5.35710E+0
2.17654E+1, 5.58819E+0
2.17820E+1, 5.81453E+0
2.17985E+1, 6.04232E+0
2.18151E+1, 6.27799E+0
2.18316E+1, 6.52578E+0
2.18482E+1, 6.77214E+0
2.18647E+1, 7.01457E+0
2.18813E+1, 7.26325E+0
2.18978E+1, 7.52036E+0
2.19144E+1, 7.78043E+0
2.19309E+1, 8.04784E+0
2.19474E+1, 8.32569E+0
2.19640E+1, 8.58662E+0
2.19805E+1, 8.84777E+0
2.19971E+1, 9.11342E+0
2.20136E+1, 9.38811E+0
2.20302E+1, 9.66982E+0
2.20467E+1, 9.96040E+0
2.20633E+1, 1.02555E+1
2.20798E+1, 1.05464E+1
2.20963E+1, 1.08525E+1
2.21129E+1, 1.11599E+1
2.21294E+1, 1.14715E+1
2.21460E+1, 1.17683E+1
2.21625E+1, 1.20701E+1
2.21791E+1, 1.23773E+1
2.21956E+1, 1.26874E+1
2.22122E+1, 1.29977E+1
2.22287E+1, 1.33079E+1
2.22452E+1, 1.36195E+1
2.22618E+1, 1.39242E+1
2.22783E+1, 1.42359E+1
2.22949E+1, 1.45455E+1
2.23114E+1, 1.48653E+1
2.23280E+1, 1.51832E+1
2.23445E+1, 1.55017E+1
2.23611E+1, 1.58197E+1
2.23776E+1, 1.61304E+1
2.23942E+1, 1.64282E+1
2.24107E+1, 1.67272E+1
2.24272E+1, 1.70312E+1
2.24438E+1, 1.73185E+1
2.24603E+1, 1.76112E+1
2.24769E+1, 1.78961E+1
2.24934E+1, 1.81835E+1
2.25100E+1, 1.84615E+1
2.25265E+1, 1.87412E+1
2.25431E+1, 1.90086E+1
2.25596E+1, 1.92748E+1
2.25761E+1, 1.95385E+1
2.25927E+1, 1.97908E+1
2.26092E+1, 2.00339E+1
2.26258E+1, 2.02595E+1
2.26423E+1, 2.04982E+1
2.26589E+1, 2.07156E+1
2.26754E+1, 2.09295E+1
2.26920E+1, 2.11137E+1
2.27085E+1, 2.13079E+1
2.27250E+1, 2.14938E+1
2.27416E+1, 2.16734E+1
2.27581E+1, 2.18316E+1
2.27747E+1, 2.19795E+1
2.27912E+1, 2.21347E+1
2.28078E+1, 2.22564E+1
2.28243E+1, 2.23831E+1
2.28409E+1, 2.24940E+1
2.28574E+1, 2.25970E+1
2.28740E+1, 2.26842E+1
2.28905E+1, 2.27778E+1
2.29070E+1, 2.28538E+1
2.29236E+1, 2.29180E+1
2.29401E+1, 2.29710E+1
2.29567E+1, 2.30102E+1
2.29732E+1, 2.30474E+1
2.29898E+1, 2.30697E+1
2.30063E+1, 2.30813E+1
2.30229E+1, 2.30778E+1
2.30394E+1, 2.30792E+1
2.30559E+1, 2.30574E+1
2.30725E+1, 2.30341E+1
2.30890E+1, 2.30035E+1
2.31056E+1, 2.29683E+1
2.31221E+1, 2.29145E+1
2.31387E+1, 2.28472E+1
2.31552E+1, 2.27834E+1
2.31718E+1, 2.27035E+1
2.31883E+1, 2.26284E+1
2.32049E+1, 2.25203E+1
2.32214E+1, 2.24239E+1
2.32379E+1, 2.23218E+1
2.32545E+1, 2.22211E+1
2.32710E+1, 2.20964E+1
2.32876E+1, 2.19512E+1
2.33041E+1, 2.18192E+1
2.33207E+1, 2.16935E+1
2.33372E+1, 2.15899E+1
2.33538E+1, 2.14462E+1
2.33703E+1, 2.12641E+1
2.33868E+1, 2.11037E+1
2.34034E+1, 2.09461E+1
2.34199E+1, 2.07821E+1
2.34365E+1, 2.06204E+1
2.34530E+1, 2.04454E+1
2.34696E+1, 2.02740E+1
2.34861E+1, 2.00959E+1
2.35027E+1, 1.99164E+1
2.35192E+1, 1.97351E+1
2.35357E+1, 1.95543E+1
2.35523E+1, 1.93689E+1
2.35688E+1, 1.91795E+1
2.35854E+1, 1.89922E+1
2.36019E+1, 1.87974E+1
2.36185E+1, 1.86001E+1
2.36350E+1, 1.83997E+1
2.36516E+1, 1.82050E+1
2.36681E+1, 1.80014E+1
2.36847E+1, 1.77942E+1
2.37012E+1, 1.75865E+1
2.37177E+1, 1.73857E+1
2.37343E+1, 1.71909E+1
2.37508E+1, 1.69913E+1
2.37674E+1, 1.67900E+1
2.37839E+1, 1.65890E+1
2.38005E+1, 1.63806E+1
2.38170E+1, 1.61547E+1
2.38336E+1, 1.59387E+1
2.38501E+1, 1.57345E+1
2.38666E+1, 1.55296E+1
2.38832E+1, 1.53195E+1
2.38997E+1, 1.51085E+1
2.39163E+1, 1.48980E+1
2.39328E+1, 1.46852E+1
2.39494E+1, 1.44765E+1
2.39659E+1, 1.42667E+1
2.39825E+1, 1.40590E+1
2.39990E+1, 1.38526E+1
2.40155E+1, 1.36473E+1
2.40321E+1, 1.34403E+1
2.40486E+1, 1.32320E+1
2.40652E+1, 1.30293E+1
2.40817E+1, 1.28225E+1
2.40983E+1, 1.26112E+1
2.41148E+1, 1.24041E+1
2.41314E+1, 1.22032E+1
2.41479E+1, 1.20033E+1
2.41645E+1, 1.18078E+1
2.41810E+1, 1.16139E+1
2.41975E+1, 1.14142E+1
2.42141E+1, 1.12189E+1
2.42306E+1, 1.10318E+1
2.42472E+1, 1.08502E+1
2.42637E+1, 1.06623E+1
2.42803E+1, 1.04739E+1
2.42968E+1, 1.02900E+1
2.43134E+1, 1.01121E+1
2.43299E+1, 9.93479E+0
2.43464E+1, 9.75683E+0
2.43630E+1, 9.58753E+0
2.43795E+1, 9.41615E+0
2.43961E+1, 9.24431E+0
2.44126E+1, 9.06896E+0
2.44292E+1, 8.90208E+0
2.44457E+1, 8.73534E+0
2.44623E+1, 8.57371E+0
2.44788E+1, 8.41354E+0
2.44953E+1, 8.25399E+0
2.45119E+1, 8.09526E+0
2.45284E+1, 7.93971E+0
2.45450E+1, 7.79756E+0
2.45615E+1, 7.65252E+0
2.45781E+1, 7.51187E+0
2.45946E+1, 7.36695E+0
2.46112E+1, 7.23033E+0
2.46277E+1, 7.09269E+0
2.46443E+1, 6.95418E+0
2.46608E+1, 6.81775E+0
2.46773E+1, 6.68820E+0
2.46939E+1, 6.56419E+0
2.47104E+1, 6.44303E+0
2.47270E+1, 6.32618E+0
2.47435E+1, 6.19386E+0
2.47601E+1, 6.08027E+0
2.47766E+1, 5.95765E+0
2.47932E+1, 5.84283E+0
2.48097E+1, 5.71850E+0
2.48262E+1, 5.60616E+0
2.48428E+1, 5.49941E+0
2.48593E+1, 5.38926E+0
2.48759E+1, 5.28224E+0
2.48924E+1, 5.17790E+0
2.49090E+1, 5.08414E+0
2.49255E+1, 4.97855E+0
2.49421E+1, 4.88923E+0
2.49586E+1, 4.80049E+0
2.49751E+1, 4.72138E+0
2.49917E+1, 4.61626E+0
2.50082E+1, 4.51706E+0
2.50248E+1, 4.41501E+0
2.50413E+1, 4.31977E+0
2.50579E+1, 4.23568E+0
2.50744E+1, 4.15101E+0
2.50910E+1, 4.07679E+0
2.51075E+1, 3.98877E+0
2.51241E+1, 3.91155E+0
2.51406E+1, 3.82154E+0
2.51571E+1, 3.75216E+0
2.51737E+1, 3.66375E+0
2.51902E+1, 3.58892E+0
2.52068E+1, 3.52489E+0
2.52233E+1, 3.45215E+0
2.52399E+1, 3.37957E+0
2.52564E+1, 3.30916E+0
2.52730E+1, 3.25068E+0
2.52895E+1, 3.17965E+0
2.53060E+1, 3.11990E+0
2.53226E+1, 3.04469E+0
2.53391E+1, 2.97463E+0
2.53557E+1, 2.90161E+0
2.53722E+1, 2.83994E+0
2.53888E+1, 2.77572E+0
2.54053E+1, 2.71819E+0
2.54219E+1, 2.67217E+0
2.54384E+1, 2.61757E+0
2.54550E+1, 2.57456E+0
2.54715E+1, 2.52225E+0
2.54880E+1, 2.46970E+0
2.55046E+1, 2.40408E+0
2.55211E+1, 2.35575E+0
2.55377E+1, 2.30456E+0
2.55542E+1, 2.26082E+0
2.55708E+1, 2.18743E+0
2.55873E+1, 2.12326E+0
2.56039E+1, 2.07153E+0
2.56204E+1, 2.03362E+0
2.56369E+1, 2.00186E+0
2.56535E+1, 1.96746E+0
2.56700E+1, 1.94248E+0
2.56866E+1, 1.90348E+0
2.57031E+1, 1.87459E+0
2.57197E+1, 1.82844E+0
2.57362E+1, 1.78181E+0
2.57528E+1, 1.70956E+0
2.57693E+1, 1.64556E+0
2.57858E+1, 1.59854E+0
2.58024E+1, 1.55838E+0
2.58189E+1, 1.50409E+0
2.58355E+1, 1.45352E+0
2.58520E+1, 1.42740E+0
2.58686E+1, 1.40401E+0
2.58851E+1, 1.39785E+0
2.59017E+1, 1.38893E+0
2.59182E+1, 1.38232E+0
2.59348E+1, 1.35856E+0
2.59513E+1, 1.32923E+0
2.59678E+1, 1.29309E+0
2.59844E+1, 1.24794E+0
2.60009E+1, 1.20018E+0
2.60175E+1, 1.14475E+0
2.60340E+1, 1.09203E+0
2.60506E+1, 1.02892E+0
2.60671E+1, 9.82924E-1
2.60837E+1, 9.48051E-1
2.61002E+1, 9.30118E-1
2.61167E+1, 9.17495E-1
2.61333E+1, 9.13329E-1
2.61498E+1, 9.16854E-1
2.61664E+1, 9.19684E-1
2.61829E+1, 9.24675E-1
2.61995E+1, 9.23182E-1
2.62160E+1, 9.08796E-1
2.62326E+1, 8.80982E-1
2.62491E+1, 8.52995E-1
2.62656E+1, 8.10104E-1
2.62822E+1, 7.59401E-1
2.62987E+1, 7.04368E-1
2.63153E+1, 6.50627E-1
2.63318E+1, 6.04323E-1
2.63484E+1, 5.56328E-1
2.63649E+1, 5.22405E-1
2.63815E+1, 5.04595E-1
2.63980E+1, 4.95981E-1
2.64146E+1, 4.84538E-1
2.64311E+1, 4.87764E-1
2.64476E+1, 5.07190E-1
2.64642E+1, 5.29375E-1
2.64807E+1, 5.50564E-1
2.64973E+1, 5.58378E-1
2.65138E+1, 5.65053E-1
2.65304E+1, 5.58647E-1
2.65469E+1, 5.42118E-1
2.65635E+1, 5.15275E-1
2.65800E+1, 4.87290E-1
2.65965E+1, 4.41943E-1
2.66131E+1, 3.90685E-1
2.66296E+1, 3.46846E-1
2.66462E+1, 2.99203E-1
2.66627E+1, 2.61673E-1
2.66793E+1, 2.18408E-1
2.66958E+1, 1.94476E-1
2.67124E+1, 1.66225E-1
2.67289E+1, 1.55548E-1
2.67454E+1, 1.48330E-1
2.67620E+1, 1.59568E-1
2.67785E+1, 1.77782E-1
2.67951E+1, 1.95457E-1
2.68116E+1, 2.28420E-1
2.68282E+1, 2.42759E-1
2.68447E+1, 2.74214E-1
2.68613E+1, 2.98872E-1
2.68778E+1, 3.23898E-1
2.68944E+1, 3.00977E-1
2.69109E+1, 2.84792E-1
2.69274E+1, 2.50127E-1
2.69440E+1, 2.27200E-1
2.69605E+1, 1.93648E-1
2.69771E+1, 1.47909E-1
2.69936E+1, 1.28567E-1
2.70102E+1, 9.62312E-2
2.70267E+1, 6.25963E-2
2.70433E+1, 1.95528E-2
2.70598E+1, 0.00000E+0
##END=$$ End of the data block



`;

export default secJcamp3;
